<template>
  <div class="strategy-detail__header">
    <Heading class="strategy-detail__text" :level="3">
      {{ detailProps.managementType.title }}
    </Heading>

    <template v-for="(text, index) in detailProps.managementType.description">
      <BaseText
        :key="index"
        class="strategy-detail__text"
        :color="nebraska.textSecondary"
        size="lg"
      >
        {{ text }}
      </BaseText>
    </template>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';

import { Heading, BaseText } from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { IPortfolioSummaryDetailsProps } from '@/modules/wallet-builder/src/services/types/models/IBffInvestments';

@Component({
  components: {
    Heading,
    BaseText
  }
})
export default class StrategyDetail extends Vue {
  readonly nebraska = NebraskaColors;

  @Prop({ type: Object, required: true })
  readonly detailProps!: {
    managementType: IPortfolioSummaryDetailsProps;
  };
}
</script>

<style lang="less" scoped>
.strategy-detail {
  &__text {
    margin-bottom: @size-spacing-x400;
    text-align: start;
  }
  &__header {
    margin-bottom: @size-spacing-x400;
  }
}
</style>
